export default __webpack_public_path__ + "static/media/IMG_0048_5_11zon.ef3f767c.jpg";